import { Box, Container, Paper, Stack } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../../api/request';
import Alert from '../../../components/common/Alert.component';
import Back from '../../../components/common/Back.component';
import Loading from '../../../components/common/Loading.component';
import AddView from '../../../views/Add.view';
import provisions from '../../../module/provisions';
import { API as departments } from '../../../module/departments/api';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import YachtForm from '../../../components/yacht/YachtForm.component';
import AgentNAForm from '../../../components/agentNA/AgentNAForm.component';
import { API as yachts } from '../../../module/yachts/api';

const ProvisionsAddPage = () => {
  const navigate = useNavigate();
  const { code, create, tag } = provisions;
  const { jwt, user } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [idDepartment, setIdDepartment] = useState(null);
  const [error, setError] = useState(false);

  const userInCharge = useMemo(
    () =>
      user && user?.id_users_nautica?.id
        ? {
            id: user?.id_users_nautica?.id,
            name: `${user?.name} ${user?.surname}`,
          }
        : null,
    [user]
  );
  const onError = useCallback(() => {
    setSuccess(false);
    setLoading(false);
    setError(true);
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(() => {
    setError(false);
    setSuccess(true);
    setLoading(false);
  }, [setSuccess, setLoading, setError]);

  const onSubmit = useCallback(
    (values) => {
      setSuccess(false);
      setLoading(true);
      setError(false);

      fetchAPI(
        provisions.query.create.settings,
        {},
        '',
        {
          ...values,
          id_department: idDepartment,
          id_user_last_updated: user?.id_users_nautica?.id || null,
        },
        jwt
      )
        .then((response) => {
          const id_operation = response?.data?.id;
          const id_list = response?.data?.attributes?.id_list?.data?.id;
          setError(false);
          setSuccess(true);
          setLoading(false);
          navigate(`/department/provisions/${id_operation}/list/${id_list}`, {
            replace: true,
            state: {
              id_operation: `${id_operation}`,
              yachtName:
                values?.id_yacht?.name &&
                _.head(_.split(values?.id_yacht?.name, '#')),
              orderType: values?.id_service?.name,
            },
          });
        })
        .catch(onError);
    },
    [setLoading, jwt, onError, idDepartment, user, navigate]
  );

  useEffect(() => {
    fetchAPI(departments.select, { code: code }, '', null, jwt)
      .then((response) => {
        setIdDepartment(_.head(response)?.id);
      })
      .catch(onError);
  }, [code, jwt, onError]);

  return (
    <Container disableGutters={true} maxWidth={false} sx={{ height: '100%' }}>
      <Stack
        spacing={2}
        sx={{ padding: 2 }}
        justifyContent='center'
        alignItems='center'
      >
        <Back title={tag} />
        <Container>
          {loading && <Loading />}
          {success && <Alert severity='success'>{'Success: Add'}</Alert>}
          {error && <Alert severity='error'>{'An error has occurred'}</Alert>}

          <Paper variant='outlined'>
            <Box sx={{ padding: 2 }}>
              {idDepartment && (
                <AddView
                  conf={{
                    ...create?.conf,
                    defaultValues: {
                      ...create?.conf?.defaultValues,
                      id_user_in_charge: userInCharge,
                    },
                  }}
                  disabled={loading}
                  onAddSubmit={onSubmit}
                  onAddError={onError}
                  onAddSuccess={onSuccess}
                  actions={
                    <Stack spacing={1}>
                      <YachtForm api={yachts.selectNoDRAFT} />
                      <AgentNAForm />
                    </Stack>
                  }
                />
              )}
            </Box>
          </Paper>
        </Container>
      </Stack>
    </Container>
  );
};

export default ProvisionsAddPage;
